"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typestyle_1 = require("typestyle");
var styles_1 = require("../styles");
var kPadding = 'calc(1.875rem / 2)';
var container = typestyle_1.style({
    background: styles_1.getHex('brand2'),
    color: styles_1.getHex('textlight'),
    display: 'inline-block',
    fontSize: '0.875rem',
}, 
// only use the relative reset on larger screens
// without this, the usermenu dropdown component will scale to fit the entire
// screenwidth
styles_1.forDesktop({
    position: 'relative',
}));
var userDetails = typestyle_1.style({
    display: 'flex',
    alignItems: 'center',
    padding: kPadding,
    height: '2rem',
    overflow: 'hidden',
});
var profileLink = typestyle_1.style({
    color: styles_1.getHex('textlight'),
    textDecoration: 'none',
    display: 'grid',
    gridAutoFlow: 'column',
    alignItems: 'center',
});
var userName = typestyle_1.style({
    paddingLeft: '1rem',
    cursor: 'pointer',
    textAlign: 'center',
    maxWidth: '6rem',
}, 
// no name component on smaller screens
styles_1.forMobile({
    display: 'none',
}));
var arrow = typestyle_1.style({
    paddingLeft: '1rem',
    cursor: 'pointer',
});
var menu = typestyle_1.style({
    background: styles_1.getHex('brand2'),
    position: 'absolute',
    gridArea: 'items',
    display: 'grid',
    width: '100%',
    zIndex: 101,
    $nest: {
        '& > a': {
            textDecoration: 'none',
            color: styles_1.getHex('textlight'),
            padding: 'calc(1.875rem / 2) 1.875rem',
        },
    },
}, styles_1.forMobile({
    position: 'absolute',
    left: 0,
    width: '100vw',
}));
exports.styles = {
    container: container,
    userDetails: userDetails,
    profileLink: profileLink,
    userName: userName,
    arrow: arrow,
    menu: menu,
};
